import Reveal from "@/components/Reveal";

const PILLARS = [
  { n: "01", t: "CONTENIDO", d: "Contenido pensado para generar confianza, no solo visualizaciones." },
  { n: "02", t: "MARCA", d: "Una imagen que te hace reconocible y de fiar." },
  { n: "03", t: "POSICIONAMIENTO", d: "Para que tu negocio deje de verse igual que el resto." },
  { n: "04", t: "CAPTACIÓN", d: "Atraemos personas con intención real, no curiosos." },
];

export default function PillarsStrip() {
  return (
    <section data-testid="pillars-strip" className="relative border-t border-b border-white/5 bg-[#070707]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 lg:py-16">
        <Reveal>
          <div data-testid="especializacion-line" className="mb-12 lg:mb-14 flex items-start gap-3 max-w-3xl">
            <span className="mt-1.5 h-4 w-[3px] bg-[#00A0A0] flex-none" />
            <p className="font-body text-sm sm:text-base leading-relaxed">
              <span className="text-white/45">No trabajamos con concesionarios oficiales ni rent-a-car.</span>{" "}
              Trabajamos con <span className="text-white font-semibold">compra-ventas, importadores y detailing</span> que quieren dejar de competir solo por precio.
            </p>
          </div>
        </Reveal>
        <Reveal>
          <div className="font-stencil text-[10px] text-[#00A0A0] tracking-[0.3em] mb-8">► UN SISTEMA QUE COMBINA</div>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={i * 80}>
              <div className="group bg-[#070707] p-6 lg:p-8 hover:bg-[#0d0d0d] transition-colors duration-500 h-full relative">
                <div className="font-stencil text-[11px] text-[#FFD700]/60 tracking-widest mb-3">{p.n}</div>
                <h3 className="font-stencil text-lg lg:text-xl text-white tracking-tight mb-2 uppercase">{p.t}</h3>
                <p className="text-sm text-white/55 leading-relaxed font-body">{p.d}</p>
                <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00A0A0] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
